import { lazyLoad } from 'utils/loadable';

export const CentreListPage = lazyLoad(
  () => import('./index'),
  module => module.CentreListPage,
);
